import React, { useState } from 'react';
import { Button } from './button';

interface AlphaNumericKeyboardProps {
  onKeyPress: (key: string) => void;
  onClear: () => void;
  onDelete: () => void;
  onSubmit?: () => void;
  showSubmitButton?: boolean;
}

export const AlphaNumericKeyboard: React.FC<AlphaNumericKeyboardProps> = ({
  onKeyPress,
  onClear,
  onDelete,
  onSubmit,
  showSubmitButton = false
}) => {
  const [isUpperCase, setIsUpperCase] = useState(true);
  const [showNumbers, setShowNumbers] = useState(false);
  
  const letters1 = ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'];
  const letters2 = ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'];
  const letters3 = ['Z', 'X', 'C', 'V', 'B', 'N', 'M'];
  const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
  const symbols = ['-', '.', '_', '@', '#', '$', '%', '&', '*', '+'];

  const handleKeyPress = (key: string) => {
    onKeyPress(isUpperCase ? key : key.toLowerCase());
  };

  const toggleCase = () => {
    setIsUpperCase(!isUpperCase);
  };

  const toggleKeyboard = () => {
    setShowNumbers(!showNumbers);
  };

  return (
    <div className="bg-gray-100 p-2 rounded-lg mt-2">
      {!showNumbers ? (
        <>
          <div className="grid grid-cols-10 gap-1 mb-1">
            {letters1.map((key) => (
              <Button
                key={key}
                type="button"
                variant="secondary"
                size="sm"
                className="py-1 px-2"
                onClick={() => handleKeyPress(key)}
              >
                {isUpperCase ? key : key.toLowerCase()}
              </Button>
            ))}
          </div>
          <div className="grid grid-cols-9 gap-1 mb-1">
            {letters2.map((key) => (
              <Button
                key={key}
                type="button"
                variant="secondary"
                size="sm"
                className="py-1 px-2"
                onClick={() => handleKeyPress(key)}
              >
                {isUpperCase ? key : key.toLowerCase()}
              </Button>
            ))}
          </div>
          <div className="flex mb-1">
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="mr-1 flex-shrink-0"
              onClick={toggleCase}
            >
              {isUpperCase ? '⇧' : '⇪'}
            </Button>
            <div className="grid grid-cols-7 gap-1 flex-grow">
              {letters3.map((key) => (
                <Button
                  key={key}
                  type="button"
                  variant="secondary"
                  size="sm"
                  className="py-1 px-2"
                  onClick={() => handleKeyPress(key)}
                >
                  {isUpperCase ? key : key.toLowerCase()}
                </Button>
              ))}
            </div>
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="ml-1 flex-shrink-0 text-red-500 border-red-200 hover:bg-red-50"
              onClick={onDelete}
            >
              ←
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="space-y-2">
            <div className="grid grid-cols-3 gap-2">
              {numbers.map((key) => (
                <Button
                  key={key}
                  type="button"
                  variant="secondary"
                  size="sm"
                  className="py-2 px-2 text-lg"
                  onClick={() => handleKeyPress(key)}
                >
                  {key}
                </Button>
              ))}
            </div>
            
            <div className="grid grid-cols-3 gap-2">
              <Button 
                type="button" 
                variant="outline" 
                size="sm" 
                onClick={onDelete}
                className="py-2 text-red-500 border-red-200 hover:bg-red-50"
              >
                ←
              </Button>
              
              <Button
                type="button"
                variant="secondary"
                size="sm"
                className="py-2 text-lg"
                onClick={() => handleKeyPress('0')}
              >
                0
              </Button>
              
              <Button 
                type="button" 
                variant="outline" 
                size="sm" 
                onClick={onClear}
                className="py-2 text-red-500 border-red-200 hover:bg-red-50"
              >
                C
              </Button>
            </div>
          </div>
          <div className="grid grid-cols-10 gap-1 mb-1">
            {symbols.map((key) => (
              <Button
                key={key}
                type="button"
                variant="secondary"
                size="sm"
                className="py-1 px-2"
                onClick={() => handleKeyPress(key)}
              >
                {key}
              </Button>
            ))}
          </div>
        </>
      )}
      
      <div className="grid grid-cols-3 gap-1 mt-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={toggleKeyboard}
        >
          {showNumbers ? 'ABC' : '123'}
        </Button>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => handleKeyPress(' ')}
          className="col-span-1"
        >
          Espacio
        </Button>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onClear}
          className="text-red-500 border-red-200 hover:bg-red-50"
        >
          Borrar
        </Button>
        
        {showSubmitButton && (
          <Button
            type="button"
            variant="primary"
            size="sm"
            onClick={onSubmit}
            className="col-span-3 mt-2"
          >
            Aceptar
          </Button>
        )}
      </div>
    </div>
  );
};
